<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-alert-circle"
    :style="iconStyle"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  color: {
    type: String,
    default: "currentColor",
  },
  size: {
    type: [String, Number],
    default: 24,
  },
});

// Computed style for the icon
const iconStyle = computed(() => ({
  color: props.color,
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>
